<template lang="html">
  <div class="fileFor">
    <div class="fileForContent">
      <div class="fileForHeader">
        <img src="../../assets/image/postCertificate/logo.png" alt="">
        <h1 class="heading--primary">中国电子学会《高速PCB设计(初级)》</h1>
        <h2 class="heading--second"> 职业技能证书报名申领 </h2>
      </div>

      <!-- 表单 -->
      <div class="fileForForm">
        <div class="nameModel certificateName">
          <label class="label">证书名称：</label>
          <span class="value">《高速PCB设计(初级)》职业技能证书</span>
        </div>

        <!-- 姓名 -->
        <div class="nameModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>姓名：</p>
          </div>
          <input class="userName" placeholder="请输入姓名" name="userName" maxlength="16" type="text" v-model="userName">
        </div>

        <!-- 身份证号 -->
        <!-- <div class="identityCardModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>身份证号：</p>
          </div>
          <input class="identityCard" placeholder="请输入身份证号码" name="identityCard" maxlength="25" type="text" v-model="userId">
        </div> -->

        <!-- <div class="siteModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>邮寄地址：</p>
          </div>
          <textarea class="mailLocation" placeholder="请输入证书邮寄地址" name="mailLocation"  maxlength="76" v-model="address"/>
          <p class="siteAnnotation">20个工作日发出纸质证书，EMS到付</p>
        </div> -->

        <!-- 备注 -->
        <!-- <div class="remarkModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>备注：</p>
          </div>
          <input class="remark" placeholder="请输入备注" name="remark" maxlength="16" type="text" v-model="remark">
        </div> -->

        <!-- 学校 -->
        <div class="nameModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>学校：</p>
          </div>
          <input class="userSchool" placeholder="请输入学校" name="userSchool" maxlength="16" type="text" v-model="userSchool">
        </div>

        <!-- 企业 -->
        <div class="nameModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>专业：</p>
          </div>
          <input class="userPosition" placeholder="请输入专业" name="userPosition" maxlength="16" type="text" v-model="userPosition">
        </div>

        <!-- 手机号 -->
        <div class="cellPhoneNumberModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>手机号：</p>
          </div>
          <!-- @input="phoneInput" -->
          <input class="userPhone" placeholder="请输入手机号码" name="userPhone" maxlength="16" type="text"  v-model="userPhone">
        </div>

        <!-- 验证码 -->
        <div class="verificationCodeModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>验证码：</p>
          </div>
          <div class="verificationCodeCon">
            <input class="verificationCode" placeholder="请输入验证码" name="verificationCode" maxlength="6" type="text" v-model="code">
            <div class="codeNum" :class="{checkValid: codeEnabled}" @click="getSmsCode">{{ buttonMsg }}</div>
          </div>
        </div>

        <!-- 支付方式 -->
        <div class="paymentModel">
          <div class="label">
            <img src="../../assets/image/postCertificate/icon6.png" alt="">
            <p>支付方式：</p>
          </div>

          <div class="paymentWay">
            <div class="postDirectionOption postDirectionOptionWay" @click="getPayTypeItemClick('wechat')">
              <img class="checkIcon" v-if="thirdPartPayType == 'wechat'" src="../../assets/image/postCertificate/icon5.png" alt="">
              <div class="checkInactive" v-else></div>
              <img class="paymentImg" src="@/assets/image/payment/wechat_pay.png" alt="">
              <p>微信支付</p>
            </div>

            <div class="postDirectionOption postDirectionOptionWay" v-if="!isInWx" @click="getPayTypeItemClick('alipay')">
              <img class="checkIcon" v-if="thirdPartPayType == 'alipay'" src="../../assets/image/postCertificate/icon5.png" alt="">
              <div class="checkInactive" v-else></div>
              <img class="paymentImg" src="@/assets/image/payment/alipay.png" alt="">
              <p>支付宝支付</p>
            </div>
          </div>
        </div>

        <!-- 合计 -->
        <div class="totalMoneyModel">
          <div>合计：</div>
          <p>￥{{ finalAmount }}</p>
        </div>

        <div class="submitModel" @click="getSubmit">
          提交并支付
        </div>
      </div>
    </div>

    <div v-show="hintShow" class="hintMod">
      <p>{{hintCon}}</p>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils'
  import WxPay from '@/utils/wxpay'

  var word = /^([\u4E00-\u9FA5]+|[a-zA-Z]+)+$/;
  // var userId = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/;
  var phone = /^1[3456789]\d{9}$/;

  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
        methodType: '',
        userName: '',
        userId: '',
        address: '',
        remark: '',
        userSchool: '',
        userPosition: '',
        userPhone: '',
        code: '',
        limitTime: 60,
        buttonMsg: '获取验证码',
        codeEnabled: false,
        hintShow: false,
        hintTime: 1,
        hintCon: '',
        thirdPartPayType: 'wechat',  /* wechat, alipay*/
        finalAmount: '',
        succeedUrl: decodeURIComponent(this.$route.query.succeedUrl) || '',
        order: localStorage.getItem('tradeSn') || '',
        openid: this.$route.query.openid || '',
        isInWx: utils.browserChecker.isWx(),
        isInPc: !(utils.browserChecker.isIOS() || utils.browserChecker.isAndroid()),
        channel: this.$route.query.channel,
      }
    },

    created(){
      this.getOrderInfo();
      this.wx = new WxPay();

      /*如果当前页面存在订单，则先查询订单状态*/
      this.order && this.polling();
    },

    mounted() {
      document.title = '信息填写'; 
    },

    destroyed(){
      this.intervalPolling && clearInterval(this.intervalPolling)
    },

    methods: {
      // 活动详情
      getOrderInfo() {
        this.$http('activity/Info', {
          params: {
            activity_id: this.aid
          }
        }).then(res => {
          if(res.code >= 0){
            this.finalAmount = res.data.cash_price
          }else{
            this.setHintCon(res.msg)
          }
        })
      },

      // 方向选择
      getPostMethodType( type ) {
        this.methodType = type;
      },

      // 获取验证码
      getSmsCode() {
        if (this.codeEnabled || this.userPhone) {
          this.$http.get('/Registered/getPhoneSmsCode', {
            params: utils.cso({
              phone: this.userPhone,
              phone_head: 86,
              type: 10,
              client: 'H5'
            })
          }).then((res) => {
            if (res.code >= 0) {
              this.codeEnabled = true;
              this.buttonMsg = this.limitTime + 's'
              this.timer = window.setInterval(() => {
                this.limitTime--
                this.buttonMsg = this.limitTime + 's'
                if (this.limitTime < 0) {
                  window.clearInterval(this.timer)
                  this.codeEnabled = false;
                  this.buttonMsg = '获取验证码'
                  this.limitTime = 60
                }
              }, 1000)
            } else {
              this.setHintCon(res.msg);
            }
          })
        }
      },

      // 支付方式选择
      getPayTypeItemClick(type) {
        this.thirdPartPayType = type;
      },

      // 提交验证
      getSubmit() {
        // 方向
        // if (this.methodType > 0) {
          // 姓名
          if (word.test(this.userName) && this.userName) {
            if (this.userSchool != '') {
              if (this.userPosition != '') {
                // 手机号
                if (phone.test(this.userPhone) && this.userPhone) {
                  if (this.code != '') {
                    this.$http({
                      url: '/activity/activityRegister',
                      method: 'post',
                      params: {
                        activity_id: this.aid,
                        name: this.userName,
                        university: this.userSchool,
                        position: this.userPosition,
                        phone: this.userPhone,
                        sms_code: this.code,
                      }
                    }).then(res => {
                      if(res.code >= 0) {
                        if(!res.data.need_pay) {
                          window.location.replace(this.succeedUrl)
                        } else {
                          this.payOrder(res.data)
                        }
                      } else {
                        this.setHintCon(res.msg)
                        if(res.code == -21){
                          setTimeout(() => {
                            window.location.replace(this.succeedUrl)
                          }, 2000)
                        }
                      }
                    })
                  } else {
                    this.setHintCon('验证码不能为空');
                  }
                } else {
                  this.setHintCon('请填写您的手机号');
                }
              } else {
                this.setHintCon('请填写您的专业');
              }
            } else {
              this.setHintCon('请填写您的学校');
            }
          } else {
            this.setHintCon('请填写您的姓名');
          }
        // } else {
        //   this.setHintCon('请选择您的技术方向');
        // }
      },

      payOrder(snData) {
        this.order = snData.order_sn;
        let payTypeMap = {
          wechat: 'WechatPay_MWeb',
          alipay: 'Alipay_LegacyWap',
          elecnest: 'Coin'
        }
        if(this.isInPc){
          /*如果不是在ios或android内，则默认是pc内打开*/
          payTypeMap.wechat = 'WechatPay_Native'
          payTypeMap.alipay = 'Alipay_LegacyExpress'
        }else if(this.isInWx){
          /*若是手机微信内打开，则微信支付时转用jsApi支付*/
          payTypeMap.wechat = 'WechatPay_Js'
        }
        if(this.thirdPartPayType == 'alipay'){
          /*如果是支付宝支付，那么只能在当前上报数据给b站，之后跟踪不到*/
          window.bilicm.mbase.report_data()
        }
        this.$http('activity/dopay', {
          params: {
            gateway: payTypeMap[this.thirdPartPayType],
            type: 'purchase',
            order_sn: this.order,
            amount: this.finalAmount,
            openid: this.openid,
            succeed_url: this.$route.query.succeedUrl || '',
          }
        }).then(res => {
          if(res.code >= 0) {
            let data = res.data
            if(data.status == 'paid'){
              localStorage.removeItem('tradeSn')
              clearInterval(this.intervalPolling)
              this.setHintCon('支付成功')
              window.location.replace(this.succeedUrl)
            }else{
              data.tradeSn && localStorage.setItem('tradeSn', data.tradeSn)
              switch(this.thirdPartPayType) {
                case 'wechat': {
                  if(this.isInPc) {
                    this.polling()
                  }else if(this.isInWx) {
                    /*如果是微信内支付，则调用jsapi唤起微信支付*/
                    this.wx.pay(data, this.polling.bind(this))
                  } else {
                    this.polling()
                    location.href = data.mwebUrl + "&redirect_url=" + encodeURIComponent('https://edu.eda365.com/h5/m/index.html#/authenticationSucceed?aid=' + this.aid)
                  }
                  break
                }
                case 'alipay': {
                  if(this.isInPc) {
                    /*如果是网页用支付宝支付，则跳转支付二维码*/
                    location.href = data.qrcodeUrl
                  }else{
                    setTimeout(() => {
                      document.write(data.paymentHtml)
                    }, 500)
                  }
                  break
                }
              }
            }
          } else {
            this.setHintCon(res.msg)
          }
        })
      },

      polling(){
        let tradeSn = localStorage.getItem('tradeSn')
        this.intervalPolling && clearInterval(this.intervalPolling)
        this.intervalPolling = setInterval(() => {
          if( tradeSn ){
            this.$http('activity/getTradeStatus', {
              params: {trade_sn: tradeSn}
            }).then(res => {
              if(res.code >= 0 && res.data.status == 'paid'){
                localStorage.removeItem('tradeSn')
                clearInterval(this.intervalPolling)
                this.setHintCon('支付成功')
                setTimeout(() => {
                  window.location.replace(this.succeedUrl)
                }, 1000)
              }
            })
          }else{
            clearInterval(this.intervalPolling)
          }
        }, 1500)
      },

      // 提示信息
      setHintCon(e) {
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },
    }
  }
</script>

<style lang="css" scoped>
  .fileForContent {
    box-sizing: border-box;
  }

  .fileForHeader {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fileForHeader img {
    width: auto;
    height: 2.6rem;
    margin-top: .8rem;
  }

  /* .fileForTitle1 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333333;
    margin-top: 1.35rem;
  }

  .fileForTitle2 {
    font-size: 1.8rem;
    color: #555555;
    margin-top: 1rem;
  } */

  .heading--primary {
    font-size: 2.1rem;
    color: rgb(134, 39, 28);
     margin-top: 4rem;
  }
  .heading--second {
    font-size: 2rem;
    color: rgb(249, 96, 46);
    margin-top: 2rem;
  }

  /* 表单样式 */
  .fileForForm {
    box-sizing: border-box;
    padding: 0 1.5rem;
    padding-bottom: 4rem;
    margin-top: 5.5rem;
  }

  .methodModel {
    box-sizing: border-box;
  }

  .label {
    box-sizing: border-box;
    display: flex;
    font-size: 1.6rem;
    font-weight: 600;
    color: #333333;
  }

  .certificateName{
    align-items: center;
  }

  .certificateName .label + .value {
    font-size: 1.4rem;
    color: #333333;
  }

  .label img {
    width: auto;
    height: .7rem;
    margin-top: .4rem;
    margin-right: .2rem;
  }

  /* 方向 */
  .postDirection {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .postDirectionOption {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-top: .9rem;
  }

  .checkIcon {
    width: 2rem;
    height: 2rem;
    margin-right: .65rem;
  }

  .checkInactive {
    width: 2rem;
    height: 2rem;
    background-image: url('../../assets/image/postCertificate/icon4.png');
    background-size: cover;
    background-repeat: no-repeat;
    margin-right: .65rem;
  }

  /* 姓名 */
  .nameModel {
    box-sizing: border-box;
    display: flex;
    padding: 1.5rem 0;
    margin-top: 1rem;
    border-bottom: .05rem solid #EEEEEE;
  }

  .userName, .userSchool, .userPosition {
    box-sizing: border-box;
    width: 27.8rem;
    font-size: 1.6rem;
    color: #333333;
    border: none;
    outline: none;
  }

  .userName[name="userName"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  .userSchool[name="userSchool"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  .userPosition[name="userPosition"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }
  
  /* 身份证号 */
  .identityCardModel {
    box-sizing: border-box;
    display: flex;
    padding: 1.5rem 0;
    border-bottom: .05rem solid #EEEEEE;
  }

  .identityCard {
    box-sizing: border-box;
    width: 24.6rem;
    font-size: 1.6rem;
    color: #333333;
    border: none;
    outline: none;
  }

  .identityCard[name="identityCard"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  /* 地址 */
  .siteModel {
    box-sizing: border-box;
    margin-top: 1.35rem;
  }

  .mailLocation {
    box-sizing: border-box;
    width: 33.85rem;
    height: 10.3rem;
    margin-left: 1rem;
    margin-top: .45rem;
    padding: .95rem 1.6rem;
    font-size: 1.6rem;
    color: #333333;
    font-family: -webkit-body;
    resize: none;
    outline: none;
    border: none;
    border-radius: .4rem;
    background-color: #F6F6F6;
  }

  .mailLocation[name="mailLocation"]::-webkit-input-placeholder {
    color: #B0B0B0;
  }

  .siteAnnotation {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333333;
    margin-top: .3rem;
    margin-left: 1rem;
  }

  /* 备注 */
  .remarkModel {
    box-sizing: border-box;
    display: flex;
    padding: 1.5rem 0;
    margin-top: 1rem;
    border-bottom: .05rem solid #EEEEEE;
  }

  .remarkModel .label img {
    opacity: 0;
  }
  
  .remark {
    box-sizing: border-box;
    width: 27.8rem;
    font-size: 1.6rem;
    color: #333333;
    border: none;
    outline: none;
  }

  .remark[name="remark"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }
  
  /* 手机号 */
  .cellPhoneNumberModel {
    box-sizing: border-box;
    display: flex;
    padding: 1.5rem 0;
    border-bottom: .05rem solid #EEEEEE;
  }

  .userPhone {
    box-sizing: border-box;
    width: 26.2rem;
    font-size: 1.6rem;
    color: #333333;
    border: none;
    outline: none;
  }

  .userPhone[name="userPhone"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  /* 验证码 */
  .verificationCodeModel {
    box-sizing: border-box;
    display: flex;
    padding: 1.5rem 0;
    border-bottom: .05rem solid #EEEEEE;
  }

  .verificationCodeCon {
    box-sizing: border-box;
    width: 26.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .verificationCode {
    box-sizing: border-box;
    width: 9.6rem;
    font-size: 1.6rem;
    color: #333333;
    border: none;
    outline: none;
  }

  .verificationCode[name="verificationCode"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  .codeNum {
    box-sizing: border-box;
    width: 8.1rem;
    font-size: 1.6rem;
    color: #1383FC;
    margin-right: .6rem;
    text-align: center;
  }

  .checkValid {
    color: #F7443F;
  }

  /* 支付方式 */
  .paymentModel {
    box-sizing: border-box;
    margin-top: 3rem;
  }

  .paymentWay {
    display: flex;
  }

  .postDirectionOptionWay {
    margin-right: 2rem;
  }

  .paymentImg {
    width: 2rem;
    height: 2rem;
    margin-right: .55rem;
  }
  
  /* 合计 */
  .totalMoneyModel {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3.15rem;
  }

  .totalMoneyModel div {
    font-size: 1.4rem;
    color: #3F454B;
  }

  .totalMoneyModel p {
    font-size: 2.4rem;
    font-weight: 600;
    color: #E50120;
  }

  /* 提交 */
  .submitModel {
    width: 100%;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F7443F;
    color: #FCFCFC;
    font-size: 1.7rem;
    border-radius: .4rem;
    margin-top: 3rem;
  }

  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  
  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(29, 32, 35, 0.5);
    font-size: 1.3rem;
    color: #FFFFFF;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>